import { render } from "./ResetPasswordModal.vue?vue&type=template&id=4fbd312c&scoped=true"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=4fbd312c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbd312c"]])

export default __exports__